function compactObject(value) {
  return Object.fromEntries(
    Object.entries(value).filter(
      ([, entry]) => entry !== undefined && entry !== null,
    ),
  )
}

function toSingleOrArray(entries) {
  if (!entries.length) {
    return undefined
  }

  return entries.length === 1 ? entries[0] : entries
}

function buildCampEventLocation(event, options = {}) {
  if (options.isTlaHosted && options.businessLocationId) {
    return { "@id": options.businessLocationId }
  }

  return {
    "@type": "Place",
    name: event.venueName || event.location,
    address: compactObject({
      "@type": "PostalAddress",
      streetAddress: event.streetAddress,
      addressLocality: event.city,
      postalCode: event.postalCode,
      addressRegion: event.region,
      addressCountry: event.addressCountry,
    }),
  }
}

function buildCampEventOffers(event, options = {}) {
  const offers = (event.offers || []).map((offer) =>
    compactObject({
      "@type": "Offer",
      name: offer.name,
      price: offer.price,
      priceCurrency: offer.priceCurrency,
      availability: options.eventHasEnded
        ? "https://schema.org/SoldOut"
        : offer.availability,
      url: offer.url,
      validFrom: offer.validFrom,
    }),
  )

  return toSingleOrArray(offers)
}

function buildCampEventOrganizers(event, options = {}) {
  const organizers = (event.organizers || []).map((organizer) => ({
    "@type": "Organization",
    name: organizer.name,
    url: organizer.url,
  }))

  if (!organizers.length && options.isTlaHosted && options.organizationId) {
    return { "@id": options.organizationId }
  }

  return toSingleOrArray(organizers)
}

function getCampEventStartDate(event) {
  return event.startDateTime || event.startDate
}

function getCampEventEndDate(event) {
  return event.endDateTime || event.endDate
}

module.exports = {
  buildCampEventLocation,
  buildCampEventOffers,
  buildCampEventOrganizers,
  getCampEventEndDate,
  getCampEventStartDate,
}
